const FeedEvents = new EventTarget();

export const subscriptions = new Map([
  ['FeedEvents', FeedEvents],
]);
